import { Ass_01, Ass_03 } from "../../Chart.js";
import { NewEntry } from "../../entry/NewEntry.js";
import { Template } from "../../template/Template.js";
import { findVariableValue } from "../../template/findVariableValue.js";

export const CASH: Template = {
  id: "f2869e09-c4ca-4ce7-a5ce-39bd03360d5b",
  name: "Raha kassasse",
  variables: [
    {
      name: "Date",
      type: "date"
    },
    {
      name: "Amount",
      type: "amount_eur"
    }
  ],
  initialValues: [
    {
      name: "Amount",
      value: "145.00"
    }
  ],
  generate: (values) => {
    const date = findVariableValue("Date", values);
    const amount = Math.round(parseFloat(findVariableValue("Amount", values)) * 100);

    const entry: NewEntry = {
      title: "Sularaha kassasse",
      items: [
        {
          title: "Sularaha kassasse",
          date: date,
          amount: amount,
          eurAmount: amount,
          currency: "eur",
          debit: Ass_01,
          credit: Ass_03
        }
      ]
    };

    return { type: "success", entry };
  }
};
